import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api, { getToken, setToken, publicApi } from "@/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [authState, setAuthState] = useState("checking"); // 'checking' | 'authed' | 'anon'

    const refresh = useCallback(async () => {
        const t = getToken();
        if (!t) {
            setAuthState("anon");
            return;
        }
        try {
            await api.get("/auth/me");
            setAuthState("authed");
        } catch {
            setToken(null);
            setAuthState("anon");
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = useCallback(async (password) => {
        const { data } = await publicApi.post("/auth/login", { password });
        setToken(data.token);
        setAuthState("authed");
        return data;
    }, []);

    const logout = useCallback(async () => {
        try {
            await api.post("/auth/logout");
        } catch {
            /* ignore */
        }
        setToken(null);
        setAuthState("anon");
    }, []);

    return (
        <AuthContext.Provider value={{ authState, login, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
